import styled from "styled-components";

export const HomepageWrapper = styled.div`
  min-height: 100vh;
  max-width: 1244px;
  margin: 0 auto;
`;
